var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"160px","height":"32px","left":"50%","top":"50%","position":"absolute","margin-left":"-80px","margin-top":"-16px","text-align":"center"}},[(_vm.isLoading)?[_vm._v(" Вжуууух... ")]:[_vm._v(" Упс... здесь пусто :( ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }